import { Capacitor } from '@capacitor/core';

export const isNativeApp = () => Capacitor.isNativePlatform();

// Public links must never contain a WebView's local origin.
export const getPublicOrigin = () => isNativeApp()
  ? (process.env.REACT_APP_PUBLIC_ORIGIN || 'https://cuplio.nl').replace(/\/$/, '')
  : window.location.origin;

export const getApiUrl = (path) => {
  if (!path.startsWith('/api/')) throw new Error('Ongeldig API-adres');
  return isNativeApp()
    ? `${(process.env.REACT_APP_API_ORIGIN || getPublicOrigin()).replace(/\/$/, '')}${path}`
    : path;
};

export const getAuthRedirect = (path) => isNativeApp()
  ? `cuplio://app${path}`
  : `${getPublicOrigin()}${path}`;

const APP_PATHS = /^\/(?:app|input|leaderboard|log|settlements|admin|profile|stats|onboarding|register|login|confirmed|reset-password|p|pay|privacy|terms|super-admin)(?:\/|$)/;

export const getAppLinkPath = (rawUrl) => {
  try {
    const url = new URL(rawUrl);
    const publicUrl = new URL(getPublicOrigin());
    const trusted = (url.protocol === 'cuplio:' && url.hostname === 'app')
      || (url.protocol === 'https:' && url.origin === publicUrl.origin);
    if (!trusted || url.username || url.password || !APP_PATHS.test(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};
